import { render, staticRenderFns } from "./OsMakeChange.vue?vue&type=template&id=deb1929a"
import script from "./OsMakeChange.vue?vue&type=script&lang=js"
export * from "./OsMakeChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports